
import { ApiService } from '../';

export const NuggetService = {
    get(slug) {
        return ApiService.get('nugget', slug);
    }
};